/**
 * AB Tasty selectors for `data-ab-test` attributes.
 *
 * Convention: `<area>-<page>-<section>-[<element>-]<action>` (kebab-case).
 *
 * Segments:
 *  - area:    consumer | dealer | admin
 *  - page:    route slug, e.g. homepage, faq, blog-post, my-auctions
 *  - section: region inside the page, e.g. hero, faq, instructions
 *  - element: (optional) button | link | cta — only when needed to disambiguate
 *  - action:  verb-noun describing intent, e.g. read-more, start-auction
 *
 * Stability rule: values are immutable once shipped to production.
 * To replace an ID, add a new key alongside the old one and remove
 * the old key only after every running AB Tasty test that references
 * it has ended.
 *
 * Usage:
 *   import AB_TEST_IDS from "@/src/constants/abTestIds";
 *   <Button data-ab-test={AB_TEST_IDS.consumer.homepage.faq.readMore}>…</Button>
 *
 * Never hardcode `data-ab-test="…"` inline — always read from this registry.
 */
export const AB_TEST_IDS = {
  consumer: {
    homepage: {
      faq: {
        readMore: "consumer-homepage-faq-read-more"
      },
      hero: {
        primaryCta: "consumer-homepage-hero-primary-cta"
      },
      instructions: {
        carCta: "consumer-homepage-instructions-car-cta",
        motoCta: "consumer-homepage-instructions-moto-cta",
        caravanCta: "consumer-homepage-instructions-caravan-cta"
      }
    },
    auctionWizard: {
      nav: {
        next: "consumer-auction-wizard-nav-next",
        previous: "consumer-auction-wizard-nav-previous",
        saveAsDraft: "consumer-auction-wizard-nav-save-draft",
        publish: "consumer-auction-wizard-nav-publish",
        cancel: "consumer-auction-wizard-nav-cancel",
        returnToSummary: "consumer-auction-wizard-nav-return-to-summary",
        startNew: "consumer-auction-wizard-nav-start-new"
      },
      finished: {
        showAuction: "consumer-auction-wizard-finished-show-auction",
        beelyLink: "consumer-auction-wizard-finished-beely-link"
      }
    }
  }
} as const;

export default AB_TEST_IDS;
